"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XPD_FALLBACK_MANIFEST = exports.DEFAULT_LANGUAGE = exports.CONCUR_NONCE_HEADER = exports.CONCUR_CSP_HEADER = exports.CONCUR_CSPRO_HEADER = void 0;
/*
Trusted domains used for setting Content Security Policy
Source: http://www.concurtraining.com/customers/tech_pubs/Docs/Z_SuppConfig/Supported_Configurations_for_Concur_Travel_and_Expense.pdf
Removed `DOMAINS_TRUSTED` as API Gateway is now managing CSP
*/

var XPD_FALLBACK_MANIFEST = exports.XPD_FALLBACK_MANIFEST = {
  'help-portal': {
    enabled: true,
    requiresSession: true,
    configOptions: {
      userAssistanceSettingsEnabled: false,
      cobrowsingEnabled: false,
      walkmeEnabled: false,
      liveChatEnabled: false
    },
    integrityHash: {
      js: {
        '/coreui/help-portal/help-portal-v2.10.7/help-portal-v2.10.7.js': 'sha384-MSpPP6F/wEf07/KEyupr8EX8Y33yX/OgIKXUNykv0U6n4UOn5qylStppqj7s7Zwv'
      },
      css: {}
    },
    files: {
      js: ['/coreui/help-portal/help-portal-v2.10.7/help-portal-v2.10.7.js'],
      css: []
    }
  },
  'on-screen-help': {
    enabled: false,
    requiresSession: true,
    integrityHash: {
      js: {
        '/on-screen-help/on-screen-help-v2.0.22-rc.7.js': 'sha384-oY8Z161eCuhgEgcy+yDzJi6lyje2e5sQn2E5Ll4GsT+doD3ZK7i3gYzUz/167qgQ'
      },
      css: {}
    },
    files: {
      js: ['/on-screen-help/on-screen-help-v2.0.22-rc.7.js'],
      css: []
    }
  },
  'ui-floorplans': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {
        '/coreui/ui-floorplans/ui-floorplans-v4.10.6/ui-floorplans-v4.10.6.js': 'sha384-gX+E348a3Dg9eI+mrtxxDrESpUMZcgILut8d+b2czqaUbSJu6Dn0B6FSN/SVrRKL'
      },
      css: {}
    },
    files: {
      js: ['/coreui/ui-floorplans/ui-floorplans-v4.10.6/ui-floorplans-v4.10.6.js'],
      css: []
    }
  },
  'monolith-widgets': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {
        '/coreui/monolith-widgets/monolith-widgets-v2.1.29/monolith-widgets-v2.1.29.js': 'sha384-k+msy3UpdW1QiT11Z97+FNg8DpuvPjrOzw0X58nvPyGe3jFmRBt5hYAYnq0x4QFz'
      },
      css: {}
    },
    files: {
      js: ['/coreui/monolith-widgets/monolith-widgets-v2.1.29/monolith-widgets-v2.1.29.js'],
      css: []
    }
  },
  'ui-custom-content': {
    enabled: true,
    requiresSession: true,
    configOptions: {
      targetSelectors: ['#company-notes-div', '#CompanyNotesDiv', '#companytextdiv', '.companytextdiv', '[data-source-type="external-html"]', '[data-element="air-search-custom-text"]', '[data-element="air-shop-custom-text"]', '[data-element="popup-configurable-message"]', '[data-element="inline-configurable-message"]', '[data-element="search-criteria-configurable-message-popup"]', '[data-element="configurable-messages-inline-section"]', '[data-element="configurable-message-popup"]', '[data-element="configurable-popup-message"]', '[data-element="shop-results-configurable-inline-message"]', '[data-element="shop-results-custom-text"]', '[data-element="car-search-form-custom-text"]', '[data-element="hotel-search-custom-text"]', '[data-element="rail-search-custom-text"]', '.customText']
    },
    integrityHash: {
      js: {
        '/coreui/ui-custom-content/ui-custom-content-v0.1.48/ui-custom-content-v0.1.48.js': 'sha384-lsAWjXgKts0Umlvk9HTlQ0zYAZLpVT8SQ/QvbjZR04XkUvItm0YTteAA8K6pM7O1'
      },
      css: {}
    },
    files: {
      js: ['/coreui/ui-custom-content/ui-custom-content-v0.1.48/ui-custom-content-v0.1.48.js'],
      css: []
    }
  },
  'translation-tool-ui': {
    enabled: true,
    requiresSession: true,
    integrityHash: {
      js: {
        '/coreui/translation-tool-ui/translation-tool-ui-v0.1.57/translation-tool-ui-v0.1.57.js': 'sha384-IhTfaRHIZ84i2utY8jrjflg1/OY2wtKbNXBgZJKgVqRJzlc1RYb2fRNL7TSv3uAL'
      },
      css: {}
    },
    files: {
      js: ['/coreui/translation-tool-ui/translation-tool-ui-v0.1.57/translation-tool-ui-v0.1.57.js'],
      css: []
    }
  },
  'ui-theming': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {},
      css: {
        '/coreui/ui-theming/ui-theming-v3.26.1/concur_android/css_variables.css': 'sha384-HrkwLirl8jqflfoKWeBT2IHK8p2+Z9oQYRunMOhRRYpLvrsn+3vvcW3LO++COFML',
        '/coreui/ui-theming/ui-theming-v3.26.1/concur_gateway/css_variables.css': 'sha384-7x71OtJID6rllG/8BNM0V8AV1z2bzFDLs/4JBoz3hvZJUJWsP8KbpTW/wU3yAA3a',
        '/coreui/ui-theming/ui-theming-v3.26.1/concur_ios/css_variables.css': 'sha384-k11WQp0NTuLHt1TK+C3amaTeYRL8TNOih5hbAgXgi0/E9G45w/zg8F96gFDt1iBO',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3/css_variables.css': 'sha384-2JuDgnW6YxV7wBY6nr7vLxbEIBNaNmx1fAn9/CyeyFalQb2Bv3eHpGM8PsjB5taK',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_dark/css_variables.css': 'sha384-SfCGfwEDpdusb+GbeBY4hplacVW8+QOxg6WUmRLa/xRNTEH3Z8c/8j+knqEt7QOk',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_hcb/css_variables.css': 'sha384-ro8JPyWabNyDSzmojIw2rVfA2uPUULdzb+D2vNaSy6+Ctn33lVzdO2TyVnV6xnWr',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_hcw/css_variables.css': 'sha384-9Eh8KAjLFoCIqWPxvIupC5AMjjT8oVAbk2pvUIb0qnKEjghqLqabHjx2rj4vzWJS',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon/css_variables.css': 'sha384-insKERlyhXXIu+k1Jwj80uUIYC86hyFOCvNsuFUCs/vAi1A+1qnPt+BMlbTeXbSE',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_dark/css_variables.css': 'sha384-74rnrEdQFmukCHpiyxK8TqH7qmvlNC5GgraUcPlsQmKeu7o4PTKV0pnk5m2xSZ32',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_hcb/css_variables.css': 'sha384-B5MorydBB1udID/B/wN19VTXVDqkHo86i0wmj4xT+mvY4K+I/iCFpztowbABEQyp',
        '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_hcw/css_variables.css': 'sha384-mSxAlgc4BFZBC447RsljdOfB1u652lL3DD39IZzJedtjYUwkjVeM5OVLeclid3BY'
      }
    },
    files: {
      js: [],
      css: ['/coreui/ui-theming/ui-theming-v3.26.1/concur_android/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/concur_gateway/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/concur_ios/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_dark/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_hcb/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_fiori_3_hcw/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_dark/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_hcb/css_variables.css', '/coreui/ui-theming/ui-theming-v3.26.1/sap_horizon_hcw/css_variables.css']
    }
  },
  'message-center': {
    enabled: true,
    requiresSession: true,
    configOptions: {},
    integrityHash: {
      js: {
        '/nui/notifications/message-center/message-center-v0.5.49/message-center-v0.5.49.js': 'sha384-zGjR0lDCzIQyW+YtCLPSORvdQcHB6R1LqxPkr+e95OvhxtuBgV6XB48tObKO+Pvx'
      },
      css: {}
    },
    files: {
      js: ['/nui/notifications/message-center/message-center-v0.5.49/message-center-v0.5.49.js'],
      css: []
    }
  }
};
var CONCUR_NONCE_HEADER = exports.CONCUR_NONCE_HEADER = 'concur-csp-nonce';
var CONCUR_CSP_HEADER = exports.CONCUR_CSP_HEADER = 'concur-content-security-policy';
var CONCUR_CSPRO_HEADER = exports.CONCUR_CSPRO_HEADER = 'concur-content-security-policy-report-only';
var DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = 'en';